import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './components/Main';
import Footer from './Footer';
import reportWebVitals from './reportWebVitals';
import './mainstyle.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Main />
    <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
